module.exports = __webpack_public_path__ + "static/media/cat-with-wry-smile-svgrepo-com.0088cc00.svg";